import { render, staticRenderFns } from "./switcherBDisabledIcon.vue?vue&type=template&id=10023e9c&"
import script from "./switcherBDisabledIcon.vue?vue&type=script&lang=js&"
export * from "./switcherBDisabledIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports